/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import qs from 'qs';

import { ROUTES } from '../constants/constants';

/** Generates the redirect URL for a logged out tenant */
export const generateRedirectURL = (tenantid: string): string =>
  ROUTES.PREAUTH + (tenantid ? `?${qs.stringify({ tenantid })}` : '');

/**
 * Determines if the initial URL was one of our defaults instead of a bookmarked link
 * @param {String} url
 */
export const isDefaultURL = (url: string): boolean =>
  url === '/' || url?.includes(ROUTES.PREAUTH) || url?.includes(ROUTES.SIGNIN);
